import { t } from '@lingui/macro';

import './LocationInput.types';

import type { SelectOption } from './LocationInput.types';

export const CURRENT_LOCATION_OPTION = (): SelectOption => ({
  label: t`Current Location`,
  value: t`Current Location`,
});
export const CURRENT_LOCATION_DENIED_MESSAGE = (): string =>
  t`We cannot access your current location. To use your current location, update your phone and browser location settings or enter your address or neighborhood in the location field.`;

export const SUGGESTION_QA_ID_PREFIX = 'suggestion';

export const LOAD_OPTIONS_DEBOUNCE_TIME = 250;
